import { S as Schema, a as StringValue } from './bueno.esm-497d7afe.js';
import { h } from './index-6e9159ae.js';
import { a as getFieldCaptions, g as getFieldValueCaption } from './field-utils-80306ff9.js';
import { i as initializePopover } from './popover-type-b7c453c7.js';
import { H as Hidden } from './initialization-utils-6efdca42.js';
import { f as escapeHtml_1, s as shouldUpdateFacetSearchComponent, d as FacetHeader, b as FacetValuesGroup, F as FacetValueLabelHighlight, g as FacetValueCheckbox, a as shouldDisplaySearchResults, e as FacetPlaceholder, c as FacetContainer } from './facet-values-group-e87e165b.js';
import { C as CloseIcon } from './close-ff816971.js';
import { S as SearchIcon } from './search-64cc84a9.js';
import { B as Button } from './button-ab6bd1ba.js';

const FacetSearchInput = (props) => {
  const label = props.i18n.t(props.label);
  const search = props.i18n.t('facet-search-input');
  const facetSearch = props.i18n.t('facet-search', { label });
  const clear = props.i18n.t('clear');
  let inputRef;
  return (h("div", { class: "px-2 mt-3", part: "search-wrapper" },
    h("div", { class: "relative h-10" },
      h("input", { part: "search-input", class: "input-primary w-full h-full px-9 placeholder-neutral-dark text-sm group", type: "text", placeholder: search, "aria-label": facetSearch, value: props.query, onInput: (e) => props.onChange(e.target.value), ref: (ref) => (inputRef = ref) }),
      h("div", { class: "search-icon pointer-events-none absolute inline-flex justify-center items-center left-0 w-9 h-full text-on-background" },
        h("atomic-icon", { part: "search-icon", icon: SearchIcon })),
      props.query !== '' && (h(Button, { style: "text-transparent", title: clear, class: "search-clear-button absolute inline-flex justify-center items-center right-px w-9 top-px bottom-px", onClick: () => {
          props.onClear();
          inputRef.focus();
        } },
        h("atomic-icon", { part: "search-clear-button", icon: CloseIcon }))))));
};

function matchesFound(key, query, i18n) {
  return i18n.t(key, {
    query: `<span class="font-bold italic text-on-background" part="matches-query">${escapeHtml_1(query)}</span>`,
    interpolation: { escapeValue: false },
  });
}
const FacetSearchMatches = (props) => {
  if (!props.numberOfMatches) {
    return (h("div", { class: "px-2" },
      h("div", { part: "no-matches", class: "truncate p-3 bg-neutral-light text-neutral-dark text-sm rounded", innerHTML: matchesFound('no-matches-found-for', props.query, props.i18n) })));
  }
  if (props.hasMoreMatches) {
    return (h("div", { class: "px-2" },
      h("div", { part: "more-matches", class: "truncate mt-3 text-neutral-dark text-sm", innerHTML: matchesFound('more-matches-for', props.query, props.i18n) })));
  }
};

const MinusIcon = `<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m64 208h384v96h-384z"/></svg>`;

const PlusIcon = `<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
  <path d="M496 208H304V16h-96v192H16v96h192v192h96V304h192"/>
</svg>
`;

const FacetShowMoreLess = (props) => {
  const label = props.i18n.t(props.label);
  const showMore = props.i18n.t('show-more');
  const showMoreFacetValues = props.i18n.t('show-more-facet-values', {
    label,
  });
  const showLess = props.i18n.t('show-less');
  const showLessFacetValues = props.i18n.t('show-less-facet-values', {
    label,
  });
  const btnClasses = 'flex items-baseline text-left p-2 text-sm max-w-full';
  const iconClasses = 'w-2 h-2 mr-1';
  if (!props.canShowLessValues && !props.canShowMoreValues) {
    return;
  }
  return (h("div", { class: "mt-2" },
    h(Button, { style: "text-primary", part: "show-less", class: `${btnClasses} ${props.canShowLessValues ? '' : 'hidden'}`, ariaLabel: showLessFacetValues, onClick: () => props.onShowLess(), ref: props.showLessRef },
      h("atomic-icon", { part: "show-more-less-icon", class: iconClasses, icon: MinusIcon }),
      h("span", { class: "truncate" }, showLess)),
    h(Button, { style: "text-primary", part: "show-more", class: `${btnClasses} ${props.canShowMoreValues ? '' : 'hidden'}`, ariaLabel: showMoreFacetValues, onClick: () => props.onShowMore(), ref: props.showMoreRef },
      h("atomic-icon", { part: "show-more-less-icon", class: iconClasses, icon: PlusIcon }),
      h("span", { class: "truncate" }, showMore))));
};

const FacetValueBox = (props, children) => {
  const compactCount = new Intl.NumberFormat(props.i18n.language, {
    notation: 'compact',
  }).format(props.numberOfResults);
  const count = props.numberOfResults.toLocaleString(props.i18n.language);
  const ariaLabel = props.i18n.t('facet-value', {
    value: props.displayValue,
    count: props.numberOfResults,
  });
  return (h("li", { key: props.displayValue },
    h(Button, { style: "outline-bg-neutral", part: `value-box${props.isSelected ? ' value-box-selected' : ''}`, onClick: () => props.onClick(), class: `value-box box-border w-full h-full items-center p-2 group ${props.isSelected ? 'selected' : ''}`, ariaPressed: props.isSelected.toString(), ariaLabel: ariaLabel, ref: props.buttonRef },
      children,
      h("span", { title: count, part: "value-count", class: "value-box-count text-neutral-dark truncate w-full text-sm mt-1" }, props.i18n.t('between-parentheses', {
        text: compactCount,
      })))));
};

const FacetValueLink = (props, children) => {
  var _a;
  const count = props.numberOfResults.toLocaleString(props.i18n.language);
  const ariaLabel = props.i18n.t('facet-value', {
    value: props.displayValue,
    count: props.numberOfResults,
    interpolation: { escapeValue: false },
  });
  let part = (_a = props.part) !== null && _a !== void 0 ? _a : `value-link${props.isSelected ? ' value-link-selected' : ''}`;
  if (props.additionalPart) {
    part += ` ${props.additionalPart}`;
  }
  return (h("li", { key: props.displayValue, class: props.class },
    h(Button, { style: "text-neutral", part: part, onClick: () => props.onClick(), class: "group w-full flex items-center px-2 py-2.5 text-left truncate no-outline", ariaPressed: props.isSelected.toString(), ariaLabel: ariaLabel, ref: props.buttonRef },
      children,
      h("span", { part: "value-count", class: "value-count" }, props.i18n.t('between-parentheses', {
        text: count,
      }))),
    props.subList));
};

function isCategoryFacetValueRequest(value) {
  return 'children' in value && Array.isArray(value.children);
}
function isFacetValueRequest(value) {
  return ('value' in value &&
    typeof value.value === 'string' &&
    !('children' in value));
}
function getSelectedCategoryFacetValueRequest(value) {
  if (value.state === 'selected') {
    return value;
  }
  for (const child of value.children) {
    const selectedValue = getSelectedCategoryFacetValueRequest(child);
    if (selectedValue !== null) {
      return selectedValue;
    }
  }
  return null;
}
function parseDependsOn(dependsOn) {
  return Object.entries(dependsOn).map(([parentFacetId, expectedValue]) => {
    return {
      parentFacetId,
      condition: (values) => {
        return values.some((value) => {
          if (isCategoryFacetValueRequest(value)) {
            const selectedValue = getSelectedCategoryFacetValueRequest(value);
            if (!selectedValue) {
              return false;
            }
            if (!expectedValue) {
              return true;
            }
            return selectedValue.value === expectedValue;
          }
          if (isFacetValueRequest(value)) {
            if (value.state !== 'selected') {
              return false;
            }
            if (!expectedValue) {
              return true;
            }
            return value.value === expectedValue;
          }
          return false;
        });
      },
    };
  });
}
function validateDependsOn(dependsOn) {
  if (Object.keys(dependsOn).length > 1) {
    throw "Depending on multiple facets isn't supported";
  }
}
function shouldDisplayInputForFacetRange(facetRange) {
  const { hasInput, hasInputRange, searchStatusState, facetValues } = facetRange;
  if (!hasInput) {
    return false;
  }
  if (hasInputRange) {
    return true;
  }
  if (!searchStatusState.hasResults) {
    return false;
  }
  const onlyValuesWithResultsOrActive = facetValues.filter((value) => value.numberOfResults || value.state !== 'idle') || [];
  if (!onlyValuesWithResultsOrActive.length) {
    return false;
  }
  return true;
}
function sortFacetVisibility(facetElements, facetInfoMap) {
  const visibleFacets = [];
  const invisibleFacets = [];
  facetElements.forEach((facet) => {
    if (facetInfoMap[facet.facetId] && facetInfoMap[facet.facetId].isHidden()) {
      invisibleFacets.push(facet);
    }
    else {
      visibleFacets.push(facet);
    }
  });
  return { visibleFacets, invisibleFacets };
}
function collapseFacetsAfter(facets, visibleFacetsCount) {
  if (visibleFacetsCount === -1) {
    return;
  }
  facets.forEach((facet, index) => {
    facet.isCollapsed = index + 1 > visibleFacetsCount;
  });
}
function isAutomaticFacetGenerator(element) {
  return element.tagName === 'ATOMIC-AUTOMATIC-FACET-GENERATOR';
}
function isPseudoFacet(el) {
  return 'facetId' in el;
}
function getFacetsInChildren(parent) {
  const facets = Array.from(parent.children).filter((child) => isPseudoFacet(child));
  return facets;
}
function getAutomaticFacetGenerator(parent) {
  return Array.from(parent.children).find(isAutomaticFacetGenerator);
}
function sortFacetsUsingManager(facets, facetManager) {
  const payload = facets.map((f) => ({
    facetId: f.facetId,
    payload: f,
  }));
  return facetManager.sort(payload).map((f) => f.payload);
}
class FacetCommon {
  constructor(opts) {
    this.resultIndexToFocusOnShowMore = 0;
    this.host = opts.host;
    this.bindings = opts.bindings;
    this.label = opts.label;
    this.field = opts.field;
    this.headingLevel = opts.headingLevel;
    this.displayValuesAs = opts.displayValuesAs;
    this.dependsOn = opts.dependsOn;
    this.dependenciesManager = opts.dependenciesManager;
    this.facet = opts.facet;
    this.facetId = opts.facetId;
    this.sortCriteria = opts.sortCriteria;
    this.withSearch = opts.withSearch;
    this.validateProps();
    const facetInfo = {
      label: () => this.bindings.i18n.t(this.label),
      facetId: this.facetId,
      element: this.host,
      isHidden: () => this.isHidden,
    };
    this.bindings.store.registerFacet('facets', facetInfo);
    initializePopover(this.host, {
      ...facetInfo,
      hasValues: () => !!this.facet.state.values.length,
      numberOfSelectedValues: () => this.numberOfSelectedValues,
    });
  }
  validateProps() {
    new Schema({
      displayValuesAs: new StringValue({
        constrainTo: ['checkbox', 'link', 'box'],
      }),
    }).validate({
      displayValuesAs: this.displayValuesAs,
    });
    validateDependsOn(this.dependsOn);
  }
  disconnectedCallback() {
    var _a;
    if (this.host.isConnected) {
      return;
    }
    (_a = this.dependenciesManager) === null || _a === void 0 ? void 0 : _a.stopWatching();
  }
  get isHidden() {
    return !this.facet.state.enabled || !this.facet.state.values.length;
  }
  componentShouldUpdate(next, prev, propName) {
    if (propName === 'facetState' && prev && this.withSearch) {
      return shouldUpdateFacetSearchComponent(next, prev);
    }
    return true;
  }
  renderHeader(headerFocus, isCollapsed, onToggleCollapse) {
    return (h(FacetHeader, { i18n: this.bindings.i18n, label: this.label, onClearFilters: () => {
        headerFocus.focusAfterSearch();
        this.facet.deselectAll();
      }, numberOfSelectedValues: this.numberOfSelectedValues, isCollapsed: isCollapsed, headingLevel: this.headingLevel, onToggleCollapse: onToggleCollapse, headerRef: (el) => headerFocus.setTarget(el) }));
  }
  get numberOfSelectedValues() {
    return this.facet.state.values.filter(({ state }) => state === 'selected')
      .length;
  }
  renderSearchInput() {
    if (!this.withSearch) {
      return;
    }
    // Hide the input if there are no more values to load from the index and there are less than 8 values to display.
    // 8 is an arbitrary number, discussed with UX as a good compromise: A list long enough where it's worth searching.
    if (!this.facet.state.canShowMoreValues &&
      this.facet.state.values.length <= 8) {
      return;
    }
    return (h(FacetSearchInput, { i18n: this.bindings.i18n, label: this.label, query: this.facet.state.facetSearch.query, onChange: (value) => {
        if (value === '') {
          this.facet.facetSearch.clear();
          return;
        }
        this.facet.facetSearch.updateCaptions(getFieldCaptions(this.field, this.bindings.i18n));
        this.facet.facetSearch.updateText(value);
        this.facet.facetSearch.search();
      }, onClear: () => this.facet.facetSearch.clear() }));
  }
  renderMatches() {
    return (h(FacetSearchMatches, { i18n: this.bindings.i18n, query: this.facet.state.facetSearch.query, numberOfMatches: this.facet.state.facetSearch.values.length, hasMoreMatches: this.facet.state.facetSearch.moreValuesAvailable }));
  }
  renderValuesContainer(children, query) {
    const classes = `mt-3 ${this.displayValuesAs === 'box' ? 'box-container' : ''}`;
    return (h(FacetValuesGroup, { i18n: this.bindings.i18n, label: this.label, query: query },
      h("ul", { class: classes, part: "values" }, children)));
  }
  renderSearchResults(showLessFocus, showMoreFocus) {
    return this.renderValuesContainer(this.facet.state.facetSearch.values.map((value) => this.renderValue({
      state: 'idle',
      numberOfResults: value.count,
      value: value.rawValue,
    }, () => this.displayValuesAs === 'link'
      ? this.facet.facetSearch.singleSelect(value)
      : this.facet.facetSearch.select(value), false, false, showLessFocus, showMoreFocus)), this.facet.state.facetSearch.query);
  }
  renderValues(showLessFocus, showMoreFocus) {
    return this.renderValuesContainer(this.facet.state.values.map((value, i) => this.renderValue(value, () => this.displayValuesAs === 'link'
      ? this.facet.toggleSingleSelect(value)
      : this.facet.toggleSelect(value), i === 0, i ===
      (this.sortCriteria === 'automatic'
        ? 0
        : this.resultIndexToFocusOnShowMore), showLessFocus, showMoreFocus)));
  }
  renderValue(facetValue, onClick, isShowLessFocusTarget, isShowMoreFocusTarget, showLessFocus, showMoreFocus) {
    const displayValue = getFieldValueCaption(this.field, facetValue.value, this.bindings.i18n);
    const isSelected = facetValue.state === 'selected';
    switch (this.displayValuesAs) {
      case 'checkbox':
        return (h(FacetValueCheckbox, { displayValue: displayValue, numberOfResults: facetValue.numberOfResults, isSelected: isSelected, i18n: this.bindings.i18n, onClick: onClick, searchQuery: this.facet.state.facetSearch.query, buttonRef: (element) => {
            isShowLessFocusTarget && showLessFocus.setTarget(element);
            isShowMoreFocusTarget && showMoreFocus.setTarget(element);
          } },
          h(FacetValueLabelHighlight, { displayValue: displayValue, isSelected: isSelected, searchQuery: this.facet.state.facetSearch.query })));
      case 'link':
        return (h(FacetValueLink, { displayValue: displayValue, numberOfResults: facetValue.numberOfResults, isSelected: isSelected, i18n: this.bindings.i18n, onClick: onClick, searchQuery: this.facet.state.facetSearch.query, buttonRef: (element) => {
            isShowLessFocusTarget && showLessFocus.setTarget(element);
            isShowMoreFocusTarget && showMoreFocus.setTarget(element);
          } },
          h(FacetValueLabelHighlight, { displayValue: displayValue, isSelected: isSelected, searchQuery: this.facet.state.facetSearch.query })));
      case 'box':
        return (h(FacetValueBox, { displayValue: displayValue, numberOfResults: facetValue.numberOfResults, isSelected: isSelected, i18n: this.bindings.i18n, onClick: onClick, searchQuery: this.facet.state.facetSearch.query, buttonRef: (element) => {
            isShowLessFocusTarget && showLessFocus.setTarget(element);
            isShowMoreFocusTarget && showMoreFocus.setTarget(element);
          } },
          h(FacetValueLabelHighlight, { displayValue: displayValue, isSelected: isSelected, searchQuery: this.facet.state.facetSearch.query })));
    }
  }
  renderShowMoreLess(showLessFocus, showMoreFocus) {
    return (h(FacetShowMoreLess, { label: this.label, i18n: this.bindings.i18n, onShowMore: () => {
        this.resultIndexToFocusOnShowMore = this.facet.state.values.length;
        showMoreFocus.focusAfterSearch();
        this.facet.showMoreValues();
      }, onShowLess: () => {
        showLessFocus.focusAfterSearch();
        this.facet.showLessValues();
      }, canShowMoreValues: this.facet.state.canShowMoreValues, canShowLessValues: this.facet.state.canShowLessValues }));
  }
  renderBody(showLessFocus, showMoreFocus) {
    return [
      this.renderSearchInput(),
      shouldDisplaySearchResults(this.facet.state.facetSearch)
        ? [
          this.renderSearchResults(showLessFocus, showMoreFocus),
          this.renderMatches(),
        ]
        : [
          this.renderValues(showLessFocus, showMoreFocus),
          this.renderShowMoreLess(showLessFocus, showMoreFocus),
        ],
    ];
  }
  render({ hasError, firstSearchExecuted, isCollapsed, numberOfValues, headerFocus, showLessFocus, showMoreFocus, onToggleCollapse, }) {
    if (hasError || !this.facet.state.enabled) {
      return h(Hidden, null);
    }
    if (!firstSearchExecuted) {
      return (h(FacetPlaceholder, { numberOfValues: numberOfValues, isCollapsed: isCollapsed }));
    }
    if (!this.facet.state.values.length) {
      return h(Hidden, null);
    }
    return (h(FacetContainer, null,
      this.renderHeader(headerFocus, isCollapsed, onToggleCollapse),
      !isCollapsed && this.renderBody(showLessFocus, showMoreFocus)));
  }
}

export { FacetValueLink as F, FacetShowMoreLess as a, FacetSearchInput as b, FacetSearchMatches as c, FacetValueBox as d, FacetCommon as e, sortFacetVisibility as f, getFacetsInChildren as g, getAutomaticFacetGenerator as h, collapseFacetsAfter as i, shouldDisplayInputForFacetRange as j, parseDependsOn as p, sortFacetsUsingManager as s, validateDependsOn as v };

//# sourceMappingURL=facet-common-525cb32f.js.map